/**
 * Module Config
 *
 * Author Matic Kogovšek [kogovsek.matic@gmail.com]
 */
export const api = process?.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:6363'

export const IS_PRODUCTION = window.location.host === 'bo.ttlive.me'
